import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedOrganizationSocieteApiService } from './organization-societe-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class OrganizationSocieteApiService extends GeneratedOrganizationSocieteApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
